export default __webpack_public_path__ + "bfdf116fce4951884f9958da6d233f78.glb";